export const environment = {
    production: true,
    hmr       : false,
    API: 'https://api-flg-qas.oficina5.com.br'
    // API: 'https://flg-monitoria-api-qas.oficina5.com.br'
};
